import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { currentHistoryIndex, loadTrail, recordLocation, saveTrail, type PageKind } from './navTrail';

/**
 * Schreibt jeden Ortswechsel in die Verlaufsspur. Genau einmal in der Portal-Shell
 * eingebaut (neben <Outlet />). Rendert nichts.
 */
export function NavTrailRecorder(): null {
  const location = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    const idx = currentHistoryIndex();
    if (idx == null) return;
    saveTrail(recordLocation(loadTrail(), { idx, key: location.key, path: location.pathname, search: location.search }, navType));
  }, [location.key, location.pathname, location.search, navType]);
  return null;
}

/**
 * Meldet den Titel der Seite für „Zurück zu …". Listen melden ihren Namen („Berichte"),
 * Dokumente ihren Titel, sobald er geladen ist.
 *
 * Trägt den Ort selbst ein, statt auf den Rekorder zu warten: Effekte der Seite laufen
 * vor denen der Shell.
 */
export function usePageLabel(label: string | null | undefined, kind: PageKind = 'other'): void {
  const location = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    const text = (label ?? '').trim();
    if (!text) return;
    const idx = currentHistoryIndex();
    if (idx == null) return;
    saveTrail(recordLocation(loadTrail(), { idx, key: location.key, path: location.pathname, search: location.search, label: text, kind }, navType));
  }, [label, kind, location.key, location.pathname, location.search, navType]);
}
